export default __webpack_public_path__ + "static/media/paylane.72a3efe8.png";